import { BaseAPI } from "@utils/base-api";
import { AxiosResponse } from "axios";

import {
  IShippingAddress,
  IShippingAddressCreateRequest,
  IShippingAddressUpdateRequest,
} from "./types/shipping";
import {
  IBillingAddress,
  IBillingAddressUpdateRequest,
  IBillingAddressCreateRequest,
} from "./types/billing";

export class AddressesAPI extends BaseAPI {

  public async getAllShippingAddresses(): Promise<AxiosResponse<{ shippingAddresses: IShippingAddress[] }>> {
    return this.axios.get(
      "customer/shipping/all",
    );
  }

  public async getShippingAddress(id: number): Promise<AxiosResponse<IShippingAddress>> {
    return this.axios.get(
      `customer/shipping/${id}`,
    );
  }

  public async createShippingAddress(
    shippingAddress: IShippingAddressCreateRequest,
  ): Promise<AxiosResponse<IShippingAddress>> {
    return this.axios.post("customer/shipping", shippingAddress);
  }

  public async updateShippingAddress(
    shippingAddressId: number,
    shippingAddress: IShippingAddressUpdateRequest,
  ): Promise<AxiosResponse<IShippingAddress>> {
    return this.axios.patch(
      `customer/shipping/${shippingAddressId}`,
      shippingAddress,
    );
  }

  public async getAllBillingAddresses(): Promise<AxiosResponse<{ billingAddresses: IBillingAddress[] }>> {
    return this.axios.get(
      "customer/billing/all",
    );
  }

  public async getBillingAddress(id: number): Promise<AxiosResponse<IBillingAddress>> {
    return this.axios.get(
      `customer/billing/${id}`,
    );
  }

  public async createBillingAddress(
    billingAddress: IBillingAddressCreateRequest,
  ): Promise<AxiosResponse<IBillingAddress>> {
    return this.axios.post("customer/billing", billingAddress);
  }

  public async updateBillingAddress(
    billingAddressId: number,
    billingAddress: IBillingAddressUpdateRequest,
  ): Promise<AxiosResponse<IBillingAddress>> {
    return this.axios.patch(
      `customer/billing/${billingAddressId}`,
      billingAddress,
    );
  }

}
